function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.41004 16.5314C8.71104 16.9047 7.87227 17.1 6.9 17.1C5.30927 17.1 4.07589 16.5772 3.22732 15.6074C2.36498 14.6218 1.8 13.0599 1.8 10.8C1.8 10.303 1.39706 9.90001 0.9 9.90001C0.402944 9.90001 0 10.303 0 10.8C0 13.3401 0.635021 15.3782 1.87268 16.7927C2.93355 18.0051 4.36468 18.6763 6 18.8526V21C6 21.4971 6.40294 21.9 6.9 21.9C7.39706 21.9 7.8 21.4971 7.8 21V18.8526C8.87901 18.7363 9.86912 18.4045 10.7226 17.8439L9.41004 16.5314ZM12.7407 15.6193C13.4423 14.3299 13.8 12.7064 13.8 10.8C13.8 10.303 13.3971 9.90001 12.9 9.90001C12.4029 9.90001 12 10.303 12 10.8C12 12.2246 11.7755 13.3718 11.3935 14.2722L12.7407 15.6193Z",
  fill: "#2E7AE2"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.30005 0C4.64319 0 3.30005 1.34314 3.30005 3V6.17873L10.4186 13.2973C10.4719 13.0735 10.5 12.8401 10.5 12.6V3C10.5 1.34315 9.1569 0 7.50005 0H6.30005ZM8.35507 15.4764L3.30005 10.4214V12.6C3.30005 14.2569 4.6432 15.6 6.30005 15.6H7.50005C7.79712 15.6 8.08411 15.5568 8.35507 15.4764Z",
  fill: "#2E7AE2"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2 7L12 17",
  stroke: "#2E7AE2",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgMicOff = function SvgMicOff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 14,
    height: 22,
    viewBox: "0 0 14 22",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMicOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mic_off.48ae816d.svg";
export { ForwardRef as ReactComponent };